"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFullText = exports.getTokensText = exports.valueTextNode = exports.getNodePositions = exports.createCssValueAST = exports.isCSSCodeAst = exports.isSeparatorToken = exports.URL_CALL_TOKEN = exports.DEFAULT_POSITION = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@tokey/core");
exports.DEFAULT_POSITION = -1;
exports.URL_CALL_TOKEN = 'url';
var isSeparatorToken = function (token) {
    var type = token.type;
    return type === 'line-comment' || type === 'multi-comment' || type === 'space';
};
exports.isSeparatorToken = isSeparatorToken;
var isCSSCodeAst = function (ast) {
    var node = ast;
    return (node.text !== undefined &&
        node.type !== undefined &&
        (node.type === 'string' ||
            node.type === 'call' ||
            node.type === 'text' ||
            node.type === ',' ||
            node.type === '/'));
};
exports.isCSSCodeAst = isCSSCodeAst;
function createCssValueAST(source, parseLineComments) {
    if (parseLineComments === void 0) { parseLineComments = false; }
    return parseDeclValueTokens(source, (0, core_1.tokenize)(source, {
        isDelimiter: isDelimiter,
        isStringDelimiter: core_1.isStringDelimiter,
        isWhitespace: core_1.isWhitespace,
        shouldAddToken: shouldAddToken,
        createToken: core_1.createToken,
        getCommentStartType: parseLineComments ? core_1.getJSCommentStartType : core_1.getMultilineCommentStartType,
        isCommentEnd: core_1.isCommentEnd,
        getUnclosedComment: core_1.getUnclosedComment,
    })).ast;
}
exports.createCssValueAST = createCssValueAST;
var isDelimiter = function (char) { return char === '(' || char === ')' || char === ',' || char === '/'; };
var shouldAddToken = function () { return true; };
function parseDeclValueTokens(source, tokens, startAtIdx) {
    var _a;
    if (startAtIdx === void 0) { startAtIdx = 0; }
    var ast = [];
    var before = [];
    for (var i = startAtIdx; i < tokens.length; i++) {
        var token = tokens[i];
        if (token.type === ')') {
            var lastAst = ast[ast.length - 1];
            if (lastAst && before.length) {
                lastAst.after = before;
                before = [];
            }
            return {
                ast: ast,
                stoppedAtIdx: i,
            };
        }
        else if ((0, exports.isSeparatorToken)(token)) {
            before.push(token);
        }
        else if (token.type === 'text' && ((_a = tokens[i + 1]) === null || _a === void 0 ? void 0 : _a.type) === '(') {
            var res = parseDeclValueTokens(source, tokens, i + 2);
            var methodText = (0, core_1.getText)(tokens, i, res.stoppedAtIdx + 1, source);
            i = res.stoppedAtIdx;
            res.ast = getUrlTokensAst(token, res.ast);
            ast.push({
                type: 'call',
                text: methodText,
                start: token.start,
                end: token.start + methodText.length,
                before: before,
                after: [],
                name: token.value,
                args: res.ast,
            });
            before = [];
        }
        else {
            ast.push({
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                type: token.type,
                text: token.value,
                start: token.start,
                end: token.end,
                before: before,
                after: [],
            });
            before = [];
        }
    }
    return {
        ast: ast,
        stoppedAtIdx: tokens.length,
    };
}
function getUrlTokensAst(token, ast) {
    var e_1, _a;
    if (token.value !== exports.URL_CALL_TOKEN || ast.length === 0) {
        return ast;
    }
    var pushFixedTextNodeToFixedAst = function () {
        if (fixedTextNode) {
            fixedTextNode.end = fixedTextNode.start + fixedTextNode.text.length;
            fixedAst.push(fixedTextNode);
            fixedTextNode = null;
        }
    };
    var fixedTextNode = null;
    var fixedAst = [];
    try {
        for (var ast_1 = tslib_1.__values(ast), ast_1_1 = ast_1.next(); !ast_1_1.done; ast_1_1 = ast_1.next()) {
            var node = ast_1_1.value;
            if (node.type === '/' || node.type === 'text') {
                if (!fixedTextNode) {
                    fixedTextNode = {
                        type: 'text',
                        text: '',
                        before: node.before,
                        after: [],
                        start: node.start,
                        end: exports.DEFAULT_POSITION,
                    };
                }
                fixedTextNode.text += node.text;
            }
            else {
                pushFixedTextNodeToFixedAst();
                fixedAst.push(node);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (ast_1_1 && !ast_1_1.done && (_a = ast_1.return)) _a.call(ast_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    pushFixedTextNodeToFixedAst();
    return fixedAst;
}
var getNodePositions = function (text, pos, spaceBefore) { return ({
    beforeStart: !spaceBefore || pos === undefined ? exports.DEFAULT_POSITION : pos - spaceBefore.length,
    beforeEnd: !spaceBefore || pos === undefined ? exports.DEFAULT_POSITION : pos,
    start: pos === undefined ? exports.DEFAULT_POSITION : pos,
    end: pos === undefined ? exports.DEFAULT_POSITION : pos + text.length,
}); };
exports.getNodePositions = getNodePositions;
var valueTextNode = function (text, pos, spaceBefore) {
    var _a = (0, exports.getNodePositions)(text, pos, spaceBefore), start = _a.start, end = _a.end, beforeEnd = _a.beforeEnd, beforeStart = _a.beforeStart;
    return {
        type: 'text',
        start: start,
        end: end,
        before: spaceBefore
            ? [
                {
                    type: 'space',
                    start: beforeStart,
                    end: beforeEnd,
                    value: spaceBefore,
                },
            ]
            : [],
        after: [],
        text: text,
    };
};
exports.valueTextNode = valueTextNode;
var getTokensText = function (tokens) {
    return tokens.map(function (token) { return token.value; }).join('');
};
exports.getTokensText = getTokensText;
var getFullText = function (ast) {
    return (0, exports.getTokensText)(ast.before) + ast.text + (0, exports.getTokensText)(ast.after);
};
exports.getFullText = getFullText;
//# sourceMappingURL=css-value-tokenizer.js.map